import React from 'react';
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Box, Button } from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';

import MainCard from 'components/MainCard';
import { getReport } from 'services/report/getReport';

function SessionSummary() {
  const navigate = useNavigate();
  const studentId = localStorage.getItem('userid');

  const { data, isLoading, error } = useQuery({
    enabled: !!studentId,
    queryKey: ['reports', studentId],
    queryFn: () => getReport({ studentId: Number(studentId) })
  });

  const reports = data?.data || [];

  const summaries = reports.slice().sort((a, b) => new Date(b.date) - new Date(a.date));

  const formatDate = (isoString) => {
    if (!isoString) return '';
    const date = new Date(isoString);
    return date.toLocaleDateString('en-GB');
  };

  const handleAsanaSelect = (report) => {
    navigate('/accuracy-breakdown', { state: report });
  };

  return (
    <MainCard title="Session Summary">
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 800 }} aria-label="Session Summary Table">
          <TableHead>
            <TableRow>
              <TableCell>#</TableCell>
              <TableCell>Date</TableCell>
              <TableCell>Course</TableCell>
              <TableCell>Asana Name</TableCell>
              <TableCell>Feedback and Tips</TableCell>
              <TableCell>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {summaries.length > 0 ? (
              summaries.map((report, index) => (
                <TableRow key={index}>
                  <TableCell>{index + 1}</TableCell>
                  <TableCell>{formatDate(report.date)}</TableCell>
                  <TableCell>{report.courseName || '-'}</TableCell>
                  <TableCell>{report.asanaName || '-'}</TableCell>
                  <TableCell>
                    {report.feedBack ? (report.feedBack.length > 30 ? report.feedBack.slice(0, 30) + '...' : report.feedBack) : '-'}
                  </TableCell>
                  <TableCell>
                    <Button variant="outlined" onClick={() => handleAsanaSelect(report)} size="small">
                      View Report
                    </Button>
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={6} align="center">
                  <Box sx={{ mt: 2, color: 'text.secondary' }}>No Reports found.</Box>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </MainCard>
  );
}

export default SessionSummary;
